export default __webpack_public_path__ + "static/barfplan-blog-promo@1x-69472ece603fdcbb75187293cdb87852.webp";